import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const ActivateCpiWrapper = styled(Box)`
  background: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 40px;

  .modal-header {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .header-top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .close-placeholder {
        width: 24px;
        height: 24px;
        opacity: 0;
      }

      .header-title {
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.bold};
        font-size: 28px;
        color: ${theme.colors.menuItemText};
        text-align: center;
        line-height: 42px;
      }

      .close-button {
        width: 24px;
        height: 24px;
        cursor: pointer;
        color: ${theme.colors.menuItemText};

        path {
          stroke: currentColor;
        }

        &:hover {
          color: ${theme.colors.cta};
        }
      }
    }

    .header-description {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.normal};
      font-size: ${theme.typography.fontSize.large};
      color: ${theme.colors.devicesSecondaryText};
      text-align: center;
      line-height: 22px;
      letter-spacing: 0.25px;
    }
  }

  .dont-show-again {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xSmall}px;

    .MuiCheckbox-root {
      padding: 0;
      width: 16px;
      height: 16px;
    }

    .dont-show-label {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.bold};
      font-size: ${theme.typography.fontSize.large};
      color: ${theme.colors.menuItemText};
      line-height: 22px;
    }
  }

  .modal-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
`
